import { IRest } from './rest.interface';
import { PlanSubject } from './subject';
import { PlanTopic } from './topic';
import { EnumHistoryType, EnumReviewStatus } from './enums';

export class StudyPage implements IRest {
    className = 'Páginas Lidas no Registro de Estudo';

    start!: number;
    end!: number;
    total!: number;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            start: this.start,
            end: this.end,
            total: this.total || undefined
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.start = data['start'] || null;
            this.end = data['end'] || null;
            this.total = data['total'] || null;
        }
        return this;
    }

}

export class StudyVideo implements IRest {
    className = 'Vídeo Assistido no Registro de Estudo';

    title!: string;
    start!: string;
    end!: string;
    total!: string;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            title: this.title,
            start: GetTotalSeconds(this.start),
            end: GetTotalSeconds(this.end),
            total: (GetTotalSeconds(this.end) ? GetTotalSeconds(this.total) : undefined)
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.title = data['title'] || '';
            this.start = GetTimeStringFormat((data['start'] || 0), true);
            this.end = GetTimeStringFormat((data['end'] || 0), true);
            this.total = GetTimeStringFormat((data['total'] || 0), true);
        }
        return this;
    }

}

export class StudyScheduleReview implements IRest {
    className = 'Informação Auxiliar da Revisão Vinculada ao Registro';

    id!: number;
    days!: number;
    status!: EnumReviewStatus;
    generateStudyId!: number;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            days: this.days,
            status: this.status,
            generateStudyId: this.generateStudyId || undefined
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.days = data['days'] || 0;
            this.status = data['status'] || EnumReviewStatus.Pending;
            this.generateStudyId = data['generateStudyId'] || 0;
        }
        return this;
    }

}

export class Study implements IRest {
    className = 'Registro de Estudo';

    id!: number;
    planId!: number;
    reviewId!: number;
    planningCycleItemId!: number;
    date!: string;
    dateComplete!: Date; //Uso Interno
    studyCategoryId!: number;
    duration!: string;
    durationSeconds!: number; //Uso Interno
    subjectId!: number;
    subject!: PlanSubject;
    topicId!: number;
    topic!: PlanTopic;
    material!: string;
    finished!: boolean;
    addToPlanning!: boolean;
    scheduleReviews!: Array<StudyScheduleReview>;
    pages!: Array<StudyPage>;
    pagesTotal!: number; //Uso Interno
    videos!: Array<StudyVideo>;
    videosTotal!: string; //Uso Interno
    questionsHit!: number;
    questionsMiss!: number;
    questionsBlank!: number;
    questionsPercentage!: number; //Uso Interno
    notes!: string;
    ownerId!: number;
    objectType: EnumHistoryType = EnumHistoryType.Study;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            planId: this.planId,
            reviewId: this.reviewId,
            planningCycleItemId: this.planningCycleItemId || undefined,
            date: this.dateComplete.toISOString(),
            studyCategoryId: this.studyCategoryId,
            duration: GetTotalSeconds(this.duration),
            subjectId: this.subjectId,
            topicId: this.topicId,
            material: this.material,
            finished: this.finished,
            addToPlanning: this.addToPlanning,
            scheduleReviews: this.scheduleReviews.map(sr => sr.Serialize()),
            pages: this.pages.map(p => p.Serialize()),
            videos: this.videos.map(v => v.Serialize()),
            questionsHit: this.questionsHit || 0,
            questionsMiss: this.questionsMiss || 0,
            questionsBlank: this.questionsBlank || 0,
            annotation: this.notes,
            objectType: this.objectType,
            // ownerId: this.ownerId

            dateStr: ToString(this.dateComplete, 'date'), //Uso Exclusivo do Servidor
            timeStr: ToString(this.dateComplete, 'time') //Uso Exclusivo do Servidor
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.planId = data['planId'] || 0;
            this.reviewId = data['reviewId'] || 0;
            this.planningCycleItemId = data['planningCycleItemId'] || 0;
            this.dateComplete = data['date'] ? new Date(data['date']) : new Date();
            this.date = GetDateFormat(data['date'] ? new Date(data['date']) : new Date(2000, 0));
            this.studyCategoryId = data['studyCategoryId'] || 0;
            this.duration = GetTimeStringFormat((data['duration'] || 0), true);
            this.durationSeconds = data['duration'] || 0;
            this.subjectId = data['subjectId'] || 0;
            this.subject = new PlanSubject(data['subject'] || {});
            this.topicId = data['topicId'] || 0;
            this.topic = new PlanTopic(data['topic'] || {});
            this.material = data['material'] || '';
            this.finished = data['finished'] || false;
            this.addToPlanning = data['addToPlanning'] || false;
            this.scheduleReviews = (data['scheduleReviews'] || data['reviews'] || []).map((sr: any) => new StudyScheduleReview(sr));
            this.pages = (data['pages'] || []).map((p: any) => new StudyPage(p));
            this.pagesTotal = this.pages.reduce((t, sp) => t + sp.total, 0);
            this.videos = (data['videos'] || []).map((v: any) => new StudyVideo(v));
            this.videosTotal = GetTimeStringFormat((data['videos'] || []).reduce((t: number, sv: any) => t + sv.total, 0), true);
            this.questionsHit = data['questionsHit'] || null;
            this.questionsMiss = data['questionsMiss'] || null;
            this.questionsBlank = data['questionsBlank'] || null;
            this.questionsPercentage = Math.round(this.questionsHit / ((this.questionsHit + this.questionsMiss) || 1) * 100);
            this.notes = data['annotation'] || '';
            this.ownerId = data['ownerId'] || 0;
        }
        return this;
    }

    ConvertDate() {
        this.date = GetDateFormat(this.dateComplete);
    }

}

export class StudyStats implements IRest {
    className = 'Estastisticas Gerais dos Registros de Estudo';

    subjectId?: number;
    subjectName?: string; //Uso Interno
    subjectColor?: string; //Uso Interno
    topicId?: number;
    topicName?: string;
    category!: string;
    periodStart?: Date;
    periodEnd?: Date;
    duration!: number;
    durationString!: string; //Uso Interno
    questionsTotal!: number;
    questionsHit!: number;
    questionsMiss!: number;
    questionsPercentage!: number; //Uso Interno
    topicsTotal!: number;
    topicsStudied!: number;
    topicsPercentage!: number; //Uso Interno
    pagesTotal!: number;
    pagesPerHour!: number;
    studiedDays!: number;
    totalDays!: number;
    durationPerDay!: number;
    durationPerDayString!: string; //Uso Interno
    videosTotal!: number;
    videosTotalString!: string; //Uso Interno

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            subjectId: this.subjectId,
            topicId: this.topicId,
            topicName: this.topicName,
            category: this.category,
            periodStart: this.periodStart,
            periodEnd: this.periodEnd,
            duration: this.duration,
            questionsTotal: this.questionsTotal,
            questionsHit: this.questionsHit,
            questionsMiss: this.questionsMiss,
            topicsTotal: this.topicsTotal,
            topicsStudied: this.topicsStudied,
            pagesTotal: this.pagesTotal,
            pagesPerHour: this.pagesPerHour,
            studiedDays: this.studiedDays,
            totalDays: this.totalDays,
            durationPerDay: this.durationPerDay,
            videosTotal: this.videosTotal
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.subjectId = data['subjectId'] || 0;
            this.topicId = data['topicId'] || 0;
            this.topicName = data['topicName'] || '';
            this.category = data['category'] || '';
            this.periodStart = data['periodStart'] ? new Date(data['periodStart']) : new Date(2000, 0);
            this.periodEnd = data['periodEnd'] ? new Date(data['periodEnd']) : new Date(2000, 0);
            this.duration = data['duration'] || 0;
            this.durationString = GetTimeStringFormat(this.duration, true, true);
            this.questionsTotal = data['questionstotal'] || data['questionsTotal'] || 0;
            this.questionsHit = data['questionshit'] || data['questionsHit'] || 0;
            this.questionsMiss = data['questionsmiss'] || data['questionsMiss'] || 0;
            this.questionsPercentage = Math.round(this.questionsHit / ((this.questionsHit + this.questionsMiss) || 1) * 100);
            this.topicsTotal = data['topicsTotal'] || 0;
            this.topicsStudied = data['topicsStudied'] || 0;
            this.topicsPercentage = Math.round(this.topicsStudied / (this.topicsTotal || 1) * 100);
            this.pagesTotal = data['pagesTotal'] || 0;
            this.pagesPerHour = data['pagesPerHour'] || 0;
            this.studiedDays = data['studiedDays'] || 0;
            this.totalDays = data['totalDays'] || 0;
            this.durationPerDay = data['durationPerDay'] || 0;
            this.durationPerDayString = GetTimeStringFormat(this.durationPerDay, true, true);
            this.videosTotal = data['videosTotal'] || 0;
            this.videosTotalString = GetTimeStringFormat(this.videosTotal, true, true);
        }
        return this;
    }

}

//Corrigir Date com as Horas e Fuso
function CorrectTimeZone(dateString: string): string {
    const newDate = new Date();
    const isoString = (dateString + 'T' + (newDate.toISOString().split('T')[1]));
    const correctedDate = new Date(isoString);
    correctedDate.setMinutes(correctedDate.getMinutes() + newDate.getTimezoneOffset());

    return correctedDate.toISOString();
}

//Obter o Total de Segundos a Partir de um Formato de Hora
function GetTotalSeconds(time: string): number {
    const complete = time.replace(':', '').replace(':', '').padStart(6, '0');
    const hours = parseInt(complete.slice(0, 2));
    const minutes = parseInt(complete.slice(2, 4));
    const seconds = parseInt(complete.slice(4, 6));

    return ((hours * 3600) + (minutes * 60) + seconds);
};

//Obter o Formato de Hora a Partir do Total de Segundos
function GetTimeStringFormat(totalSeconds: number, hourDigit?: boolean, string?: boolean): string {
    const hours = (Math.floor(totalSeconds / 3600)).toString();
    const minutes = (Math.floor((totalSeconds % 3600) / 60)).toString().padStart(2, '0');
    const seconds = (totalSeconds % 60).toString();

    if (string) return `${hours}h${minutes}min`;

    if (hourDigit)
        return (hours.padStart(2, '0') + minutes + seconds.padStart(2, '0'));
    else
        return (minutes + seconds.padStart(2, '0'));
}

//Obter a Data no Formato de Formulário 'yyyy-mm-dd'
function GetDateFormat(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    let dateFormat = (year + '-');
    dateFormat += ((month + 1).toString().padStart(2, '0'));
    dateFormat += '-';
    dateFormat += (day.toString().padStart(2, '0'));

    return dateFormat;
}

//Formatar Datetime em Data e Hora
function ToString(date: Date, type: 'date' | 'time'): string {
    let str = '';

    if (type == 'date') {
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();

        str = (year.toString().padStart(2, '0'));
        str += '-';
        str += ((month + 1).toString().padStart(2, '0'));
        str += '-';
        str += (day.toString().padStart(2, '0'));
    }
    else if (type == 'time') {
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();

        str = (hour.toString().padStart(2, '0'));
        str += ':';
        str += (minute.toString().padStart(2, '0'));
        str += ':';
        str += (second.toString().padStart(2, '0'));
    }

    return str;
}